export default class Devaluations {
  constructor(
    id,
    sum,
    startDate,
  ) {
    this.id = id;
    this.sum = sum;
    this.startDate = startDate;
  }

  static createFromData(data) {
    return new Devaluations(
      data.id,
      data.sum,
      data.startDate
    )
  }

  static createNew() {
    return new Devaluations(
      null,
      null,
      null
    );
  }
}
